import { render, staticRenderFns } from "./home_model.vue?vue&type=template&id=dbfa396c&scoped=true&"
import script from "./home_model.vue?vue&type=script&lang=js&"
export * from "./home_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfa396c",
  null
  
)

export default component.exports